var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-component", {
    attrs: {
      timestamp: _vm.timestamp,
      section: _vm.section,
      type: _vm.type,
      bindKeys: true,
      id: _vm.id,
      parent: _vm.parent,
      attributes: _vm.attributes,
      meta: _vm.meta,
      schema: _vm.schema,
      config: _vm.formConfig,
      resourceParams: _vm.resourceParams,
      changeUrl: _vm.changeUrl,
      changeSection: _vm.changeSection,
      changeQuery: _vm.changeQuery,
      haltFetch: _vm.haltFetch,
      addNotification: _vm.addNotification,
      commitQueue: _vm.commitQueue,
      pushQueue: _vm.pushQueue,
      createData: _vm.createData,
      updateData: _vm.updateData,
      deleteData: _vm.deleteData,
      onInitialized: _vm.onInitialized,
      onCreated: _vm.onCreated,
      onChanged: _vm.onChanged,
      onUpdated: _vm.onUpdated,
      onDeleted: _vm.onDeleted
    }
  })
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bd6e91e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd6e91e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/ItemComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6bd6e91e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/ItemComponent.vue
// module chunks = 0